import { useEffect, useState } from "react";

import { ArrowButton, Button } from "@king-ict/eupisi-ui/components";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { getFormOfTeachingById } from "../../api/nisooApi";
import StaticField from "../../components/StaticField";
import { FormOfTeaching } from "../../models/FormOfTeaching";
import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import { codebookRouteFormOfTeaching } from "../../routes/routes";
import styles from "./RequestCodeBook.module.scss";

export default function CodeBooFormOfTeachingDetails(): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { data: userSession } = useGetUserSessionQuery();
  const userCanEditData = userSession && (userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager 
    || userSession.roleId === RoleEnum.ASOOManager || userSession.roleId === RoleEnum.Helpdesk);

  const [formOfTeaching, setFormOfTeaching] = useState<FormOfTeaching>();

  useEffect(() => {
    if (!location || !location.state || !(location.state as any).formOfTeachingId) {
      return
    }
    const getFormOfTeaching = async () => {
      var result = await getFormOfTeachingById((location.state as any).formOfTeachingId);
      setFormOfTeaching(result);
    }
    getFormOfTeaching();
  }, [location]);

  const navigateToEdit = (item: FormOfTeaching) => {
    history.push(
      codebookRouteFormOfTeaching(),
      {
        page: "edit",
        formOfTeachingId: item.id
      }
    );
  }

  const navigateToList = () => {
    history.push(
      codebookRouteFormOfTeaching(),
      {
        page: "list"
      }
    );
  }

  return (
    <>
      {formOfTeaching &&
        <>
          <Row>
            <Col md={9}>
              <ArrowButton backwards ariaLabel="" onClick={navigateToList} />
              <span className={styles.backButtonCaption}>
                {t("codeBook.returnToList")}
              </span>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col md={8}>
              <h3>{t("codeBook.formOfTeaching")}</h3>
            </Col>
            {userCanEditData &&
              <Col md={4} className="d-flex justify-content-end align-items-center">
                <Button onClick={() => navigateToEdit(formOfTeaching)}>
                  {t("common.edit")}
                </Button>
              </Col>
            }
          </Row>
          <Row className="mt-5">
            <Col md={4} >
              <StaticField
                label={t("common.name")}
                value={formOfTeaching.name}
              />
            </Col>
            <Col md={4} >
              <StaticField
                label={t("common.dateTo")}
                value={formOfTeaching.dateTo ? hrDate(formOfTeaching.dateTo) : ""}
              />
            </Col>
          </Row>
        </>
      }
    </>
  );
}